import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d356066"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "modifyButton",
  class: "btn-confirm-wrap"
}



export default /*#__PURE__*/_defineComponent({
  __name: 'ModifyButton',
  props: {
  context: {
    type: String,
    required: false,
  },
},
  emits: ['onClick_cancel', 'onClick_modify'],
  setup(__props, { emit }) {

const props = __props;




/**** methods ----------------- */
/**** content -----------------
 *
 * 취소 / 수정 버튼
 * /
 * /
/**** hook -------------------- */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-type-1",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClick_cancel')))
    }, "취소"),
    _createElementVNode("button", {
      class: "btn btn-type-2",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onClick_modify')))
    }, "수정")
  ]))
}
}

})